import { render, staticRenderFns } from "./Quota.vue?vue&type=template&id=1ddb9a9d&scoped=true"
import script from "./Quota.vue?vue&type=script&lang=js"
export * from "./Quota.vue?vue&type=script&lang=js"
import style0 from "./Quota.vue?vue&type=style&index=0&id=1ddb9a9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddb9a9d",
  null
  
)

export default component.exports